import React from "react";
import InputTextArea from "../../../../components/InputTextArea";
import InputTextAreaStyles from "../../../../styles/components/InputTextAreaStyles";

const { StyledLabel } = InputTextAreaStyles;

interface IJustifyInformation {
    justification: string;
    setJustification: (arg0: string) => void;
}

const JustifyInformation: React.FC<IJustifyInformation> = ({
    justification,
    setJustification,
}) => {
    const placeholder =
        "Insira sua justificativa com até 500 caracteres e envie para aprovação da coordenação";

    return (
        <>
            <StyledLabel htmlFor="justifyTextbox">Justificativa</StyledLabel>
            <InputTextArea
                id="justifyTextbox"
                value={justification}
                onChange={(event: any) =>
                    setJustification(event.target.value as string)
                }
                maxLength={500}
                placeholder={placeholder}
                style={{ height: "90px" }}
            />
        </>
    );
};

export default JustifyInformation;
